import { isMultiline } from '@shared/utils/isMultiline.js';

const fieldTypes = {
  string: 'input',
  number: 'input',
  boolean: 'toggle',
  'boolean(text)': 'input',
  'boolean(toggle)': 'toggle',
  date: 'input',
  list: 'select'
};

// A `password` result is the one type that can never re-render as a textarea, so a
// newline pasted into it would be captured and then be invisible. The `allowMultiline`
// gate in ArgumentsCredentialsWrapper relies on this exact predicate. Widening the key
// regex to cover a genuinely multiline field (a certificate or private key) would
// silently flatten it on paste; getFieldType.test.js pins that invariant.
const getFieldType = (field, secrets) => {
  if (field.key?.match(/\b(api\s?key|password|secret|token|passphrase)\b/i)) {
    return 'password';
  }
  if (isMultiline(secrets?.[field.key])) {
    return 'textarea';
  }
  return fieldTypes[field.dataType || 'string'];
};

export default getFieldType;
